/**
 * Service dédié aux opérations CRUD sur les réductions
 * Centralise les appels API pour simplifier la page DiscountPage
 */
import api from '../utils/api';

const discountService = {
  /**
   * Récupère la liste complète des types de réductions (pourcentage, fixe, etc.)
   * @returns {Promise<Array>} Liste triée à afficher dans les formulaires
   */
  async getDiscountTypes() {
    try {
      const response = await api.get('/discounts/types');
      return response.data;
    } catch (error) {
      console.error('Erreur lors du chargement des types de réduction:', error);
      throw error;
    }
  },

  /**
   * Récupère les réductions de l'utilisateur avec tous les filtres nécessaires
   * @param {Object} params - search, status, typeId, page, pageSize
   * @returns {Promise<{discounts: Array, total: number, page: number, pageSize: number}>}
   */
  async listDiscounts(params = {}) {
    try {
      const query = new URLSearchParams();
      if (params.search) query.append('search', params.search);
      if (params.status) query.append('status', params.status);
      if (params.typeId) query.append('typeId', params.typeId);
      if (params.page) query.append('page', params.page);
      if (params.pageSize) query.append('pageSize', params.pageSize);

      const queryString = query.toString();
      const endpoint = queryString ? `/discounts?${queryString}` : '/discounts';
      const response = await api.get(endpoint);
      return response.data;
    } catch (error) {
      console.error('Erreur lors du chargement des réductions:', error);
      throw error;
    }
  },

  /**
   * Crée une nouvelle réduction côté API
   * @param {Object} payload - Champs envoyés par le formulaire
   * @returns {Promise<Object>} - Réduction créée
   */
  async createDiscount(payload) {
    try {
      const response = await api.post('/discounts', payload);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création d\'une réduction:', error);
      throw error;
    }
  },

  /**
   * Met à jour une réduction existante
   * @param {string} id - Identifiant de la réduction
   * @param {Object} payload - Champs modifiés
   * @returns {Promise<Object>} - Réduction mise à jour
   */
  async updateDiscount(id, payload) {
    try {
      const response = await api.put(`/discounts/${id}`, payload);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour d\'une réduction:', error);
      throw error;
    }
  },

  /**
   * Supprime définitivement une réduction
   * @param {string} id - Identifiant de la réduction
   * @returns {Promise<void>}
   */
  async deleteDiscount(id) {
    try {
      await api.delete(`/discounts/${id}`);
    } catch (error) {
      console.error('Erreur lors de la suppression d\'une réduction:', error);
      throw error;
    }
  }
};

export default discountService;
